export default __webpack_public_path__ + "static/buzzfeed-a37a0c74aa41008106fab0eb31f0e5e3.png";